import { API } from '@/api/API'
import { auth0 } from '@/helpers/Auth0Client'
import { authExternal } from '@/helpers/AuthExternal'
import { configCatRequest } from '@/helpers/ConfigCat'
import { authenticationMethod } from '@/helpers/Environment'
import store from '@/store/store'
import type VueRouter from 'vue-router'

export async function logout(router?: VueRouter, nextPath?: string) {
  const externalLogoutUrl = authExternal.externalLogoutUrl()

  // first we log out from ticketure...
  if (!externalLogoutUrl) await API.post('logout')

  await store.dispatch('clearAll')

  const { auto_login_external } = await configCatRequest

  // ...then we log out from the external provider, if any
  if (auto_login_external && authExternal.isExternalAuth()) {
    nextPath ??= window.location.pathname
    authExternal.logout(nextPath)
  } else if (!auto_login_external && authenticationMethod === 'auth0_ecomm') {
    nextPath ??= window.location.pathname
    // @see https://auth0.com/docs/quickstart/spa/vuejs/01-login#create-an-authentication-wrapper
    auth0.getAuth0Client().then((client) => {
      if (client) {
        client.logout({ returnTo: window.location.origin + nextPath })
      }
    })
  } else if (!auto_login_external && externalLogoutUrl) {
    window.location.href = externalLogoutUrl
  } else if (router && nextPath) {
    router.push(nextPath)
  }
}

export function ensureLoggedOut() {
  return isLoggedIn() ? logout() : Promise.resolve()
}

export function isLoggedIn(): boolean {
  return Boolean(store.getters['Member/user'])
}
